var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.16675V3.83341M5 2.16675V3.83341",
    stroke: "#3A86DD",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9956 11.3333H10.0031M9.9956 14.6666H10.0031M13.3252 11.3333H13.3327M6.66602 11.3333H6.67349M6.66602 14.6666H6.67349",
    stroke: "#3A86DD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91602 7.16675H17.0827",
    stroke: "#3A86DD",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08398 10.7027C2.08398 7.07162 2.08398 5.25607 3.12742 4.12803C4.17085 3 5.85023 3 9.20898 3H10.7923C14.1511 3 15.8305 3 16.8739 4.12803C17.9173 5.25607 17.9173 7.07162 17.9173 10.7027V11.1307C17.9173 14.7617 17.9173 16.5773 16.8739 17.7053C15.8305 18.8333 14.1511 18.8333 10.7923 18.8333H9.20898C5.85023 18.8333 4.17085 18.8333 3.12742 17.7053C2.08398 16.5773 2.08398 14.7617 2.08398 11.1307V10.7027Z",
    stroke: "#3A86DD",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.16675H17.5",
    stroke: "#3A86DD",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridCalendar);
export default __webpack_public_path__ + "static/media/grid-calendar.defe514232e619497117090de349f530.svg";
export { ForwardRef as ReactComponent };